import { takeLatest } from "redux-saga/effects";

import { GetEmailRes } from "../../StateManagement/Reducers/PreLoginState";
import { SendOtpWorker } from "./PreloginWorkers";

export function* SendUserOtpSaga() {
  yield takeLatest(GetEmailRes.type, SendOtpWorker);
}
